import React, { useEffect, useState } from 'react';
import { API_FightResults } from 'shared';
import fetcher from '../../../utils/fetcher';
import useAlert from '../../../contexts/alert';
import Loader from '../../../components/general/loader';
import FightResults from '../../../components/pages/fight/results';

type ResultsLoading = {
  loading: true;
  error: false;
  data: undefined;
};

type ResultsError = {
  loading: false;
  error: true;
  data: undefined;
};

type ResultsSuccess = {
  loading: false;
  error: false;
  data: API_FightResults;
};

type Results = ResultsLoading | ResultsError | ResultsSuccess;

interface Props {
  fightId: string;
  needCongrats: boolean;
}

const FightPageResults = ({ fightId, needCongrats }: Props) => {
  const alert = useAlert();
  const [results, setResults] = useState<Results>({
    data: undefined,
    error: false,
    loading: true
  });

  useEffect(() => {
    getFightResults();
  }, []);

  const getFightResults = () => {
    fetcher.fight
      .getResults(fightId)
      .then((response) => {
        setResults({ data: response, error: false, loading: false });
      })
      .catch((err) => {
        alert.showError(err);
        setResults({ data: undefined, error: true, loading: false });
      });
  };

  if (results.loading) return <Loader useAbsoluteWrapper color='primary' />;

  if (results.error) return <h1>Can't load the fight results!</h1>;

  return <FightResults results={results.data} needCongrats={needCongrats} />;
};

export default FightPageResults;
